'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("comparaisonPanelService", function ($tauxFormat, $montantFormat, $numberFormat, chartUtils, $http, $applications, $authz, tlTableUtils, tlColors) {
  /**
   *
   * les modifications de couleurs sont a répercuter dans comparaisonPanelLineCharts.js (var chartMembreColors)
   */
  var chartMembreColors = ["#0069C0", "#F77600", "#2B957A", "#e2e03a", "#f13a3a", "#69d5f6", "#72f391", "#f5d3ca", "#9fabbb", "#ac735d", "#e7b0f1"];
  var chartMoyennesColors = ["#564AA3", "#00e30b", "#fc7600"];
  var getGraphColorMoyenne = function getGraphColorMoyenne(i) {
    return chartMoyennesColors[i % chartMoyennesColors.length];
  };
  var _getGraphColorMembre = function getGraphColorMembre(i) {
    return chartMembreColors[i % chartMembreColors.length];
  };
  var buildSortFn = function buildSortFn(i) {
    return function (a, b) {
      var attrA = a.valeurs[i];
      var attrB = b.valeurs[i];
      if (attrA == null && attrB == null) {
        return 0;
      } else if (attrA == null || attrA.valeur == null) {
        return -1;
      } else if (attrB == null || attrB.valeur == null) {
        return 1;
      } else {
        return attrA.valeur.valeur < attrB.valeur.valeur ? -1 : attrA.valeur.valeur > attrB.valeur.valeur ? 1 : 0;
      }
    };
  };
  return {
    getGraphColorMembre: function getGraphColorMembre(index) {
      return _getGraphColorMembre(index);
    },
    /**
     *
     * @param $scope
     * @param params (affichePopulation:false/true), "resultat si null"
     * @param resultat
     * @param nomResultatInScope source = "nomResultatInScope".lignes
     * @returns un 'tableConfig'
     */
    buildTableConfig: function buildTableConfig($scope, params, resultat, nomResultatInScope) {
      if (nomResultatInScope == null) {
        nomResultatInScope = "resultat";
      }
      $scope.getFormatterValue = function (value, model) {
        var res;
        if (value != null && model.type === 'taux') {
          res = $tauxFormat(value.valeur, 2);
        } else if (value != null && model.type === 'nombre') {
          if (value.valeur != null) {
            console.log(model);
            res = $numberFormat(value.valeur.valeur, model.nbDecimales);
            if (_.startsWith(resultat.dataType, 'POPULATION_')) {
              res += " hab.";
            }
          }
        } else {
          res = $montantFormat(value && value.valeur, 0);
          if (resultat.parHabitant) {
            res += "/hab.";
          }
        }
        return res;
      };
      var columns = [{
        attribute: "membre",
        title: "Nom",
        template: "<span ng-class=\"{b:model.reference||model.moyenne,i:model.moyenne}\">{{model.membre}} <span ng-if='model.membreDepartement'>({{model.membreDepartement}})</span></span>" + "<span ng-if=\"model.departement\" class=\"departement-pill ml-xs\">dep.</span>" + "<span ng-if=\"model.epci\" class=\"epci-pill ml-xs\">epci</span>",
        sortable: true
      }];

      // $scope.params non dispo sur les rapports personnalisés
      if (params && params.affichePopulation) {
        columns.push({
          attribute: 'population',
          title: "Population",
          template: '<span ng-if="model.population">{{model.population|number}} hab.</span>',
          filter: 'number',
          sortable: true,
          cellClass: 'align-r',
          sortType: 'number'
        });
      }
      for (var i = 0; i < resultat.nbAnnees; i++) {
        columns.push({
          attribute: "valeurs[" + i + "]",
          title: "" + resultat.anneeMax - resultat.nbAnnees + i + 1,
          filter: 'montant',
          template: "<span ng-class=\"{b:model.reference||model.moyenne,i:model.moyenne}\">{{getFormatterValue(model.valeurs[" + i + "], model)}}</span>",
          sortable: true,
          sortType: buildSortFn(i),
          cellClass: 'align-r'
        });
      }
      return {
        source: nomResultatInScope + ".lignes",
        allowSelection: true,
        selectionAttribute: "selection",
        selectionScope: $scope,
        columns: columns
      };
    },
    /**
     *
     * @param $scope
     * @param showDetails affiche  chaque entité sur le graphe (sinon juste moyenne et référence)
     * @param selectedMembre si renseigné et !showDetails alors affichera la ligne de l'entité avec membreId == selectedMembre.membreId
     */
    buildGraphe: function buildGraphe(chartConfig, $scope, lignes, showDetails, selectedMembre, hideMoyennes) {
      chartConfig.series = [];
      var idxColorDetail = 0; // pour ne pas commencer avec les memes couleur que les moyennes
      var idxColorMoyenne = 0;
      _.forEach(lignes, function (ligne) {
        if (ligne.reference || ligne.moyenne || showDetails || !showDetails && selectedMembre && ligne.membreId === selectedMembre.membreId) {
          var line = {
            name: ligne.membre,
            color: ligne.reference ? tlColors.FUSCHIA : ligne.moyenne ? getGraphColorMoyenne(idxColorMoyenne) : ligne.couleur ? ligne.couleur : _getGraphColorMembre(idxColorDetail),
            visible: true,
            data: _.map(ligne.valeurs, function (value, key) {
              return {
                x: value.annee,
                y: value.valeur == null ? null : ligne.type == 'taux' ? value.valeur.valeur * 100.0 : value.valeur.valeur
              };
            }).filter(function (p) {
              return p.y != null;
            })
          };
          if (ligne.moyenne && !hideMoyennes) {
            if (chartConfig.options.chart.type === 'line') {
              line['dashStyle'] = 'LongDash';
            }
            //  line['opacity']=0.6;
            //line['borderColor'] = tlColors.NEW_RED_1;
            //  line['borderWidth'] =1;
          }
          if (ligne.reference) {
            line['lineWidth'] = 3;
            line['borderWidth'] = 1;
            line['borderColor'] = tlColors.INTERET_SIMULES;

            //line.pointWidth=20

            line.groupPadding = 0.17;
          }
          if (!ligne.moyenne || !hideMoyennes) {
            chartConfig.series.push(line);
          }
          if (!ligne.moyenne && !ligne.reference) {
            idxColorDetail++;
          }
          if (ligne.moyenne) {
            idxColorMoyenne++;
          }
        }
      });
    },
    createChartConfig: function createChartConfig($scope, type, params) {
      var chartConfig = {
        options: {
          chart: {
            type: params && params.typeChart || 'line',
            zoomType: 'x',
            height: 250
          },
          // pour l'affichge de l'unité sur les axes
          typeData: type,
          legend: {
            enabled: true,
            align: 'right',
            layout: 'vertical',
            verticalAlign: 'top',
            y: 30,
            backgroundColor: 'rgba(109,176,194,0.1)',
            borderWidth: 0,
            borderRadius: 0,
            symbolWidth: 30
          },
          tooltip: {
            shared: true,
            formatter: function formatter() {
              var tooltip = '<span>' + this.x + '</span> :  <br/>';
              _.each(this.points, function (point) {
                var value = type == 'taux' ? $numberFormat.percentage(point.y / 100.0, 2) : $numberFormat.number(point.y, 0);
                var label = point.series.name;
                var serieLine = '<span style="color: ' + point.series.color + '; font-weight: bold;">' + label + '</span> : ' + value + (type == null ? " €" : "");
                tooltip += serieLine + "<br/>";
              });
              return tooltip;
            }
          },
          xAxis: {
            allowDecimals: false,
            alternateGridColor: null
          },
          yAxis: {
            title: {
              text: type == null ? "" : type == 'taux' ? '' : type == 'nombre' ? '' : type == 'habitant' ? '' : ''
            },
            labels: {
              formatter: function formatter() {
                var type = this.chart.options.typeData;
                var unit = type == null ? " €" : type == 'taux' ? '%' : type == 'nombre' ? '' : type == 'habitant' ? 'h.' : ' €';
                return this.axis.defaultLabelFormatter.call(this) + unit;
              }
            },
            startOnTick: false
          }
        }
      };
      return chartConfig;
    },
    getResultat: function getResultat($scope) {
      var _this = this;
      $http.get('/rest/observatoire/comparaison/indicateur', {
        params: $scope.params
      }).then(function (result) {
        $scope.resultat = result.data;
        $scope.lignes = result.data.lignes;
        $scope.tableConfig = _this.buildTableConfig($scope, $scope.params, $scope.resultat);
        $scope.chartConfig = _this.createChartConfig($scope, $scope.resultat.type, $scope.params);
        _this.buildGraphe($scope.chartConfig, $scope, $scope.resultat.lignes, $scope.params.showDetails, $scope.selection);
      });
    },
    /**
     *
     * @param $scope
     * @param params
     */
    getResultatObsFi: function getResultatObsFi($scope, params) {
      var _this2 = this;
      return $http.get('/rest/of/comparaison/indicateur', {
        params: params
      }).then(function (result) {
        $scope.resultat = result.data;
        $scope.lignes = result.data.lignes;
        $scope.selection = tlTableUtils.getNewTableSelection($scope.selection, $scope.lignes, 'membreId');
        $scope.tableConfig = _this2.buildTableConfig($scope, params, $scope.resultat);
        $scope.chartConfig = _this2.createChartConfig($scope, $scope.resultat.type, $scope.params);
        _this2.buildGraphe($scope.chartConfig, $scope, $scope.resultat.lignes, params.showDetails, $scope.selection);
        return $scope.resultat;
      });
    },
    /**
     * liste utilisée par les carto
     */
    getIndicateursList: function getIndicateursList(type) {
      var indicateurList = [];
      if ($applications.isDetteApplication) {
        [{
          id: 'ENCOURS_DETTE',
          label: 'Dette'
        }, {
          id: 'ANNUITE_DETTE',
          label: 'Annuité'
        }, {
          id: 'AMORTISSEMENT_DETTE',
          label: 'Amortissement'
        }, {
          id: 'INTERET_DETTE',
          label: 'Intérêt'
        }, {
          id: 'DOTATION_GLOBALE_FONCTIONNEMENT',
          label: 'Dotations'
        }].forEach(function (d) {
          return indicateurList.push(d);
        });
      }
      if ($authz.hasRole('MODULE_OBSERVATOIRE_FINANCIER')) {
        if (type === 'epci') {
          [{
            id: 'RECETTES_FONCTIONNEMENT',
            section: 'Produits de fonctionnement'
          }, {
            id: 'IMPOTS_LOCAUX',
            section: 'Produits de fonctionnement'
          }, {
            id: 'REVERSEMENT_FISCALITE',
            section: 'Produits de fonctionnement'
          }, {
            id: 'AUTRES_IMPOTS_ET_TAXES',
            section: 'Produits de fonctionnement'
          }, {
            id: 'DOTATION_GLOBALE_FONCTIONNEMENT',
            section: 'Produits de fonctionnement'
          }, {
            id: 'CHARGES_FONCTIONNEMENT',
            section: 'Charge de fonctionnement'
          }, {
            id: 'CHARGES_PERSONNEL',
            section: 'Charge de fonctionnement'
          }, {
            id: 'CHARGES_EXTERNES',
            section: 'Charge de fonctionnement'
          }, {
            id: 'CHARGES_FINANCIERES',
            section: 'Charge de fonctionnement'
          }, {
            id: 'SUBVENTIONS_VERSEES',
            section: 'Charge de fonctionnement'
          }, {
            id: 'RESULTAT_COMPTABLE',
            section: 'Résultat comptable'
          }, {
            id: 'RESSOURCES_INVESTISSEMENT',
            section: 'Ressources d\'investissement'
          }, {
            id: 'EMPRUNTS_ET_DETTES_ASSIMILEES',
            section: 'Ressources d\'investissement'
          }, {
            id: 'SUBVENTIONS_RECUES',
            section: 'Ressources d\'investissement'
          }, {
            id: 'FCTVA_INVESTISSEMENT',
            section: 'Ressources d\'investissement'
          }, {
            id: 'EMPLOIS_INVESTISSEMENT',
            section: 'Emplois d\'investissement'
          }, {
            id: 'DEPENSES_EQUIPEMENT',
            section: 'Emplois d\'investissement'
          }, {
            id: 'AMORTISSEMENT_DETTE',
            section: 'Emplois d\'investissement'
          }, {
            id: 'CAF'
          }, {
            id: 'CAF_NETTE'
          }, {
            id: 'ENCOURS_DETTE',
            section: 'Endettement'
          }, {
            id: 'ANNUITE_DETTE',
            section: 'Endettement'
          }, {
            id: 'RATIO_CAPACITE_DESENDETTEMENT',
            section: 'Endettement'
          }, {
            id: 'TAXE_HABITATION_BASE'
          }, {
            id: 'TAXE_HABITATION_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_HABITATION_PRODUITS'
          }, {
            id: 'TAXE_HABITATION_TAUX'
          }, {
            id: 'TAXE_FONCIERE_BATIE_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_PRODUITS'
          }, {
            id: 'TAXE_FONCIERE_BATIE_TAUX'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_BASE'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_PRODUITS'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_TAUX'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_BASE'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_PRODUITS'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_TAUX'
          }, {
            id: 'COTISATION_VA_ENTREPRISES'
          }, {
            id: 'IMPOSITION_FORFAITAIRE_ENTREPRISES_DE_RESEAU'
          }, {
            id: 'TAXE_SURFACES_COMMERCIALES'
          }

          //{id: 'POPULATION_DGFIP'}
          ].forEach(function (d) {
            return indicateurList.push(d);
          });
        } else if (type === 'departement') {
          return [{
            id: 'RECETTES_FONCTIONNEMENT'
          }, {
            id: 'IMPOTS_LOCAUX'
          }, {
            id: 'AUTRES_IMPOTS_ET_TAXES'
          },
          // dont taxe départementale de publicité foncière et droits d'enregistrement
          {
            id: 'TAXE_DEPARTEMENTALE_PUBLICITE_FONCIERE_ET_DROITS_ENREGISTREMENT'
          }, {
            id: 'DOTATION_GLOBALE_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_PERSONNEL'
          }, {
            id: 'CHARGES_EXTERNES'
          }, {
            id: 'AIDES_PERSONNES'
          }, {
            id: 'FRAIS_SEJOURS_HEBERGEMENT'
          }, {
            id: 'CHARGES_FINANCIERES'
          }, {
            id: 'SUBVENTIONS_VERSEES'
          }, {
            id: 'RESULTAT_COMPTABLE'
          }, {
            id: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'EMPRUNTS_ET_DETTES_ASSIMILEES'
          }, {
            id: 'SUBVENTIONS_RECUES'
          }, {
            id: 'FCTVA_INVESTISSEMENT'
          }, {
            id: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'DEPENSES_EQUIPEMENT'
          }, {
            id: 'AMORTISSEMENT_DETTE'
          }, {
            id: 'SUBVENTIONS_EQUIPEMENT_VERSEES'
          }, {
            id: 'BESOIN_FINANCEMENT_RESIDUELLE_SECTION_INVESTISSEMENT'
          }, {
            id: 'SOLDE_OPERATIONS_TIERS'
          }, {
            id: 'BESOIN_FINANCEMENT_SECTION_INVESTISSEMENT'
          }, {
            id: 'RESULTAT_ENSEMBLE'
          }, {
            id: 'EXCEDENT_BRUT_FONCTIONNEMENT'
          }, {
            id: 'CAF'
          }, {
            id: 'CAF_NETTE'
          }, {
            id: 'ENCOURS_DETTE'
          }, {
            id: 'ENCOURS_DETTE_NETTE_AIDE_FOND_SOUTIEN'
          }, {
            id: 'ANNUITE_DETTE'
          }, {
            id: 'RATIO_CAPACITE_DESENDETTEMENT',
            section: 'Endettement'
          }, {
            id: 'FOND_DE_ROULEMENT'
          }, {
            id: 'TAXE_FONCIERE_BATIE_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_PRODUITS'
          }, {
            id: 'TAXE_FONCIERE_BATIE_TAUX'
          }, {
            id: 'COTISATION_VA_ENTREPRISES'
          }, {
            id: 'IMPOSITION_FORFAITAIRE_ENTREPRISES_DE_RESEAU'
          }].forEach(function (d) {
            return indicateurList.push(d);
          });
        } else {
          [{
            id: 'RECETTES_FONCTIONNEMENT',
            section: 'RECETTES_FONCTIONNEMENT'
          }, {
            id: 'IMPOTS_LOCAUX',
            section: 'RECETTES_FONCTIONNEMENT'
          }, {
            id: 'AUTRES_IMPOTS_ET_TAXES',
            section: 'RECETTES_FONCTIONNEMENT'
          }, {
            id: 'DOTATION_GLOBALE_FONCTIONNEMENT',
            section: 'RECETTES_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_FONCTIONNEMENT',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_PERSONNEL',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_EXTERNES',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_FINANCIERES',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'CONTINGENTS',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'SUBVENTIONS_VERSEES',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'RESULTAT_COMPTABLE',
            section: 'RESULTAT_COMPTABLE'
          }, {
            id: 'RESSOURCES_INVESTISSEMENT',
            section: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'EMPRUNTS_ET_DETTES_ASSIMILEES',
            section: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'SUBVENTIONS_RECUES',
            section: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'FCTVA_INVESTISSEMENT',
            section: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'RETOURS_BIENS_AFFECTES',
            section: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'EMPLOIS_INVESTISSEMENT',
            section: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'DEPENSES_EQUIPEMENT',
            section: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'AMORTISSEMENT_DETTE',
            section: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'CHARGES_INVESTISSEMENT_A_REPARTIR',
            section: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'IMMOBILISATIONS',
            section: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'BESOIN_FINANCEMENT_RESIDUELLE_SECTION_INVESTISSEMENT',
            section: 'BESOIN_FINANCEMENT_RESIDUEL'
          }, {
            id: 'SOLDE_OPERATIONS_TIERS',
            section: 'BESOIN_FINANCEMENT_RESIDUEL'
          }, {
            id: 'BESOIN_FINANCEMENT_SECTION_INVESTISSEMENT',
            section: 'BESOIN_FINANCEMENT_RESIDUEL'
          }, {
            id: 'RESULTAT_ENSEMBLE',
            section: 'BESOIN_FINANCEMENT_RESIDUEL'
          }, {
            id: 'EXCEDENT_BRUT_FONCTIONNEMENT',
            section: 'SECTION_AUTOFINANCEMENT'
          }, {
            id: 'CAF',
            section: 'AUTOFINANCEMENT'
          }, {
            id: 'CAF_NETTE',
            section: 'AUTOFINANCEMENT'
          }, {
            id: 'ENCOURS_DETTE',
            section: 'ENDETTEMENT'
          }, {
            id: 'ENCOURS_DETTE_NETTE_AIDE_FOND_SOUTIEN',
            section: 'ENDETTEMENT'
          }, {
            id: 'ANNUITE_DETTE',
            section: 'ENDETTEMENT'
          }, {
            id: 'RATIO_CAPACITE_DESENDETTEMENT',
            section: 'ENDETTEMENT'
          }, {
            id: 'FOND_DE_ROULEMENT',
            section: 'FONDS_DE_ROULEMENT'
          }, {
            id: 'TAXE_HABITATION_BASE',
            section: 'TAXE_BASE'
          }, {
            id: 'TAXE_HABITATION_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_HABITATION_PRODUITS'
          }, {
            id: 'TAXE_HABITATION_TAUX'
          }, {
            id: 'TAXE_FONCIERE_BATIE_BASE',
            section: 'TAXE_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_PRODUITS'
          }, {
            id: 'TAXE_FONCIERE_BATIE_TAUX'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_BASE',
            section: 'TAXE_BASE'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_PRODUITS'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_TAUX'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_BASE',
            section: 'TAXE_BASE'
          },
          // {id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_REDUCTIONS_BASE'},
          {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_PRODUITS'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_TAUX'
          }, {
            id: 'COTISATION_FONCIERE_ENTREPRISES_BASE',
            section: 'TAXE_BASE'
          }, {
            id: 'COTISATION_FONCIERE_ENTREPRISES_REDUCTIONS_BASE'
          }, {
            id: 'COTISATION_FONCIERE_ENTREPRISES_PRODUITS'
          }, {
            id: 'COTISATION_FONCIERE_ENTREPRISES_TAUX'
          }, {
            id: 'COTISATION_VA_ENTREPRISES'
          }, {
            id: 'IMPOSITION_FORFAITAIRE_ENTREPRISES_DE_RESEAU'
          }, {
            id: 'TAXE_SURFACES_COMMERCIALES'
          }

          //{id: 'POPULATION_DGFIP'}
          ].forEach(function (d) {
            return indicateurList.push(d);
          });
        }
      }
      return indicateurList;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/comparaisonPanel/comparaisonPanelService.js
// module id = 2693
// module chunks = 13